import { NavLink, Link } from "react-router-dom";
import { House, GridFour, FilmStrip, PlayCircle, Broadcast, Circuitry, BookOpen, Books, Briefcase, EnvelopeSimple, Sparkle } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home", icon: House, id: "rail-home" },
  { to: "/solutions", label: "Solutions", icon: GridFour, id: "rail-solutions" },
  { to: "/reels", label: "Reels", icon: FilmStrip, id: "rail-reels" },
  { to: "/live", label: "Live", icon: PlayCircle, id: "rail-live" },
  { to: "/live-vision", label: "Vision", icon: Broadcast, id: "rail-live-vision" },
  { to: "/systems", label: "Systems", icon: Circuitry, id: "rail-systems" },
  { to: "/playbooks", label: "Playbooks", icon: BookOpen, id: "rail-playbooks" },
  { to: "/knowledge", label: "Knowledge", icon: Books, id: "rail-knowledge" },
  { to: "/careers", label: "Careers", icon: Briefcase, id: "rail-careers" },
  { to: "/scoper", label: "Scoper", icon: Sparkle, id: "rail-scoper" },
  { to: "/contact", label: "Contact", icon: EnvelopeSimple, id: "rail-contact" },
];

export default function SideNavRail() {
  return (
    <aside
      data-testid="side-nav-rail"
      className="hidden md:flex fixed left-0 top-0 bottom-0 w-20 z-40 flex-col items-center py-6 border-r border-[#2A2A2A] bg-[#050505]/85 backdrop-blur overflow-y-auto"
    >
      <Link to="/" data-testid="rail-logo" className="flex flex-col items-center gap-2 shrink-0">
        <img
          src="/wisewit-emblem.png"
          alt="Wisewit"
          className="w-11 h-11 object-contain"
          style={{ display: 'block' }}
        />
        <div className="font-mono text-[9px] tracking-[0.3em] text-[#8E8E93]">WISEWIT</div>
      </Link>

      <nav className="flex flex-col items-center gap-1 my-6 shrink-0">
        {links.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={id}
            className={({ isActive }) =>
              `ww-rail-link group flex flex-col items-center gap-1 w-16 py-3 transition-colors ${
                isActive ? "text-white" : "text-[#8E8E93] hover:text-white"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={20}
                  weight={isActive ? "fill" : "regular"}
                  color={isActive ? "#FF4500" : "currentColor"}
                />
                <span className="font-mono text-[9px] tracking-[0.2em] uppercase">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="flex flex-col items-center gap-2 mt-auto shrink-0 pt-2">
        <div className="w-1.5 h-1.5 rounded-full bg-[#FF4500] ww-pulse" />
        <div className="font-mono text-[8px] tracking-[0.3em] text-[#555555] rotate-180 [writing-mode:vertical-rl]">
          v1.0 / ONLINE
        </div>
      </div>
    </aside>
  );
}
